import { useQuery } from 'react-query';
import { RequestParameters } from '../types';
import { getActivities, getLanding, getPromotions } from './api';

export enum LandingHook {
  Landing = 'landing',
  Promotions = 'promotions',
  Activities = 'activities',
  BookActivities = 'book-activities',
}

export function useLanding() {
  return useQuery([LandingHook.Landing], () => getLanding('ap'));
}

export function usePromotions(params?: RequestParameters) {
  return useQuery([LandingHook.Promotions, params], () => getPromotions(params));
}

export function useActivities(params?: RequestParameters) {
  return useQuery([LandingHook.Activities, params], () => getActivities(params));
}
